import * as React from "react";
import { forwardRef } from "react";
const SvgDotsLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("ellipse", { cx: 3.2, cy: 3.2, rx: 3.2, ry: 3.2, fill: "#FF6400" }), /* @__PURE__ */ React.createElement("ellipse", { cx: 3.2, cy: 12.7996, rx: 3.2, ry: 3.2, fill: "#FF6400" }));
const ForwardRef = forwardRef(SvgDotsLeft);
export { ForwardRef as ReactComponent };
